import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Qué recibo al comprar?',
    a: 'Acceso inmediato al programa completo + bonos digitales.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No. Está pensado para empezar desde cero.'
  }, {
    q: '¿Cuándo accedo?',
    a: 'En minutos luego del pago.'
  }, {
    q: '¿Es para cualquier país?',
    a: 'Sí. El sistema apunta al mercado internacional.'
  }, {
    q: '¿Tengo acceso para siempre?',
    a: 'Sí, acceso de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-gray-50 py-24 border-t border-gray-200" data-id="element-42">
      <div className="container mx-auto px-4" data-id="element-43">
        <FadeIn data-id="element-44">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-navy-950 mb-12" data-id="element-45">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-47">
              <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden" data-id="element-48">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-49">
                  <span className="font-bold text-navy-900 text-lg" data-id="element-50">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-51" />
                </button>
                <AnimatePresence data-id="element-52">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-53">
                      <div className="px-6 pb-5 text-gray-600" data-id="element-54">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}